import { supabase } from './supabaseClient'
import { isNativeApp } from './platform'

export const FORUM_NOTIFICATION_TYPES = ['forum_reply','forum_approved','forum_rejected','forum_pending']
export const FORUM_LANGUAGES = ['fr','de','it','en']
export const forumEnabled = (hostname = window.location.hostname, native = isNativeApp()) => !native && ['app.hubbing.ch','localhost','127.0.0.1'].includes(String(hostname).toLowerCase())
export const forumLanguage = value => FORUM_LANGUAGES.includes(value) ? value : 'fr'
export const forumDate = (value, lang = 'fr') => {
  const date = new Date(value)
  return Number.isNaN(date.getTime()) ? '' : new Intl.DateTimeFormat(`${forumLanguage(lang)}-CH`,{day:'2-digit',month:'2-digit',year:'numeric',hour:'2-digit',minute:'2-digit',timeZone:'Europe/Zurich'}).format(date)
}
export function forumInitialTarget(search = window.location.search) {
  const params = new URLSearchParams(search), target = params.get('forum')
  const validId = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(target||'')
  return validId||target==='moderation' ? {topicId:validId?target:null,moderation:target==='moderation',language:forumLanguage(params.get('forumLang'))} : null
}
export function preserveForumTarget(path, search = window.location.search) {
  const target=forumInitialTarget(search)
  if(!target)return path
  const url=new URL(path,window.location.origin)
  url.searchParams.set('forum',target.moderation?'moderation':target.topicId)
  url.searchParams.set('forumLang',target.language)
  return `${url.pathname}${url.search}`
}
async function forumRequest(name, action, payload = {}, {signal, expectedUserId, client = supabase} = {}) {
  const controller = new AbortController()
  let timeout,abort
  const deadline=new Promise((_,reject)=>{
    abort=()=>{controller.abort();reject(new Error('aborted'))}
    signal?.addEventListener('abort',abort,{once:true})
    timeout=setTimeout(()=>{controller.abort();reject(new Error('timeout'))},15000)
    if(signal?.aborted)abort()
  })
  const work=Promise.resolve().then(async()=>{
    let token
    if(controller.signal.aborted)throw new Error('aborted')
    if(expectedUserId) {
      const {data,error}=await client.auth.getSession()
      if(error||data?.session?.user?.id!==expectedUserId||!data.session.access_token)throw new Error('auth_changed')
      token=data.session.access_token
    }
    if(controller.signal.aborted)throw new Error('aborted')
    let query=client.rpc(name,{p_action:action,p_payload:payload})
    if(token)query=query.setHeader('Authorization',`Bearer ${token}`)
    const {data,error}=await query.abortSignal(controller.signal)
    if(error)throw error
    if(!data||data.ok===false)throw new Error(data?.error||'unavailable')
    return data
  })
  try{return await Promise.race([work,deadline])}
  finally{clearTimeout(timeout);signal?.removeEventListener('abort',abort)}
}
export const forumRpc = (action,payload,options) => forumRequest('hubbing_forum',action,payload,options)
export const forumUnreadRpc = (action,payload,options) => forumRequest('hubbing_forum_unread',action,payload,options)

export const forumTermsRpc = (action,payload,options) => forumRequest('hubbing_forum_terms',action,payload,options)
